import Candidate from '../Candidate';
import {
  Obj
} from '../Object.lib';

export default function patchCandidateUpdateModel(candidate) {
  candidate = Obj(candidate);
  if (candidate.country === 'parser-not-found') {
    candidate.country = '';
  }
  if (candidate.platformRating === 0) {
    candidate.platformRating = Candidate.calculatePlatformRating({
      candidate
    });
  }
  if (Array.isArray(candidate.employmentHistories)) {
    candidate.employmentHistories = candidate.employmentHistories.map(
      (employment) => {
        Object.keys(employment).forEach((key) => {
          if (String(key).includes('__')) {
            delete employment[key];
          }
        });
        return employment;
      }
    );
  }
  return candidate;
}
